import { $themeConfig } from '@themeConfig'

export default {
  isVerticalMenuCollapsed: $themeConfig.layout.menu.isCollapsed,
}
